class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;

    // Add hover behavior for desktop
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // Keep menu open when hovering over the mega menu content
    const megaMenuContent = this.mainDetailsToggle.querySelector('.mega-menu__content');
    if (megaMenuContent) {
      megaMenuContent.addEventListener('mouseenter', this.cancelClose.bind(this));
      megaMenuContent.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }

    // Handle click navigation on desktop
    const summary = this.mainDetailsToggle.querySelector('summary');
    const menuUrl = summary.getAttribute('data-menu-url');

    if (menuUrl) {
      summary.addEventListener('click', (event) => {
        // On desktop, prevent toggle and navigate to URL
        if (window.innerWidth >= 990) {
          event.preventDefault();
          window.location.href = menuUrl;
        }
      });
    }
  }

  onMouseEnter() {
    // Only open on hover for desktop (viewport width >= 990px)
    if (window.innerWidth >= 990) {
      // Cancel any pending close timeout
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
  }

  onMouseLeave() {
    // Close on mouse leave for desktop with a small delay
    if (window.innerWidth >= 990) {
      this.closeTimeout = setTimeout(() => {
        this.close();
      }, 100);
    }
  }

  cancelClose() {
    // Cancel the close timeout when mouse enters the mega menu content
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
